import React from 'react';

const Footer = () => {
    return (
        <footer className="container-footer">
            <div className="row">
                <div className="newsletter col-lg-6 col-md-12 col-6">
                    <h3 className="newsletter-naslov">Prijavite se na naš newsletter</h3>
                    <p>
                        <i className="fas fa-envelope-square"></i> E-mail{" "}
                        <input
                            type="email"
                            name="elektronicka-adresa"
                            value=""
                            maxLength="25"
                            placeholder="Unesite svoju email adresu"
                        />
                    </p>
                    <br />
                    <button className="btnnews" name="prijavi-se-na-newsletter">
                        PRIJAVA
                    </button>
                </div>

                <div className="col-lg-2 col-md-4 col-6">
                    <h4>Naše lokacije</h4>
                    <ul>
                        <li>
                            <i className="fas fa-map-marker-alt"></i> Zagreb
                        </li>
                        <li>
                            <i className="fas fa-map-marker-alt"></i> Split
                        </li>
                        <li>
                            <i className="fas fa-map-marker-alt"></i> Rijeka
                        </li>
                        <li>
                            <i className="fas fa-map-marker-alt"></i> Zadar
                        </li>
                        <li>
                            <i className="fas fa-map-marker-alt"></i> Pula
                        </li>
                        <li>
                            <i className="fas fa-map-marker-alt"></i> Osijek
                        </li>
                    </ul>
                </div>

                <div className="col-lg-2 col-md-4 col-6">
                    <h4>Brzi linkovi</h4>
                    <ul>
                        <li>
                            <a href="https://front1.edukacija.online/rhrgic/projekt/cjenikusluga.html">
                                <i className="fas fa-chevron-circle-right"></i> Cjenik usluga
                            </a>
                        </li>
                        <li>
                            <a href="https://front1.edukacija.online/rhrgic/projekt/contact.html">
                                <i className="fas fa-chevron-circle-right"></i> Kontakt
                            </a>
                        </li>
                        <li>
                            <a href="https://front1.edukacija.online/rhrgic/projekt/webshop.html">
                                <i className="fas fa-chevron-circle-right"></i> Webshop
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="col-lg-2 col-md-4 col-6">
                    <h4>Pratite nas na društvenim mrežama</h4>
                    <ul>
                        <li>
                            <a href="#">
                                <i className="fa-brands fa-instagram fa-2x"></i> Instagram
                            </a>
                        </li>
                        <li>
                            <a href="">
                                <i className="fa-brands fa-square-facebook fa-2x"></i> Facebook
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default Footer;